import MESSAGES from './ar';

export default {
  ...MESSAGES,
  'CUIT:': 'RUT:',
  'CUIT: *': 'RUT: *',
  'Debe ingresar un CUIT': 'Debes ingresar un RUT',
  CUIT: 'RUT',
};
